import { NOTIFICATION_VISIBLE_CAP, type AppNotification } from "./notification-types.js";

export function isStickyNotification(item: Pick<AppNotification, "durationMs">): boolean {
  return item.durationMs == null;
}

/**
 * Newest-first list. When over capacity, drop the oldest non-sticky toast first
 * so an active Contact Import toast stays visible.
 */
export function evictNotificationsForCapacity(
  items: readonly AppNotification[],
  cap = NOTIFICATION_VISIBLE_CAP,
): AppNotification[] {
  if (items.length <= cap) return [...items];
  const next = [...items];
  while (next.length > cap) {
    let index = -1;
    for (let i = next.length - 1; i >= 0; i--) {
      if (!isStickyNotification(next[i]!)) {
        index = i;
        break;
      }
    }
    if (index < 0) {
      index = next.length - 1;
    }
    next.splice(index, 1);
  }
  return next;
}
